module.exports = __webpack_public_path__ + "static/media/kick-that-habit-man.bbba1598.jpg";